import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import 'react-tooltip/dist/react-tooltip.css'
import 'react-simple-keyboard/build/css/index.css'
import version from './app/_constants/version.json'
import Error from './app/_features/ErrorBoundary/Error'
import { PWAUpdatePrompt } from './app/_features/PWAUpdate'
import App from './app/App'
import { syncLoginCookie } from './app/_lib/loginCookie'
import './index.css'

syncLoginCookie()

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

if (import.meta.env.MODE === 'development') {
  root.render(
    <React.StrictMode>
      <PWAUpdatePrompt>
        <App />
      </PWAUpdatePrompt>
    </React.StrictMode>
  )
} else {
  Bugsnag.start({
    apiKey: '41af1ebca3614114bde81e077de983b6',
    plugins: [new BugsnagPluginReact()],
    releaseStage: import.meta.env.MODE,
    appVersion:  version.version || 'unknown',
  })

  // @ts-expect-error Bugsnag plugin types are not fully compatible with React 19
  const BugsnagErrorBoundary = Bugsnag.getPlugin('react')
    .createErrorBoundary(React)

  root.render(
    <React.StrictMode>
      <BugsnagErrorBoundary FallbackComponent={Error}>
        <PWAUpdatePrompt>
          <App />
        </PWAUpdatePrompt>
      </BugsnagErrorBoundary>
    </React.StrictMode>
  );
}


